// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
var inject = allVue.inject;
import { classNames } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, select } from './messages';
import { UploadInput } from './UploadInput';
/**
 * @hidden
 */

/**
 * Represents the default `UploadAddButton` component.
 */

var UploadAddButtonVue2 = {
  name: 'KendoVueUploadAddButton',
  props: {
    addButtonIndex: Number,
    navigationIndex: Number,
    notFocusedIndex: Number,
    tabIndex: Number,
    async: Object,
    multiple: Boolean,
    disabled: Boolean,
    accept: String,
    id: String,
    ariaLabelledBy: String,
    ariaDescribedBy: String
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  emits: {
    'add': null,
    'click': null
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var elementRef = ref(null);
    var uploadInputRef = ref(null);
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      elementRef: elementRef,
      uploadInputRef: uploadInputRef,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  mounted: function mounted() {
    this.element = this.v3 ? this.elementRef : this.$refs.element;
    this.uploadInput = this.v3 ? this.uploadInputRef : this.$refs.uploadInput;
  },
  watch: {
    navigationIndex: function navigationIndex(_newNavigationIndex, oldNavigationIndex) {
      this._prevNavigationIndex = oldNavigationIndex;
    }
  },
  updated: function updated() {
    var _a = this.$props,
        navigationIndex = _a.navigationIndex,
        addButtonIndex = _a.addButtonIndex,
        notFocusedIndex = _a.notFocusedIndex;

    if (navigationIndex !== this._prevNavigationIndex && this._prevNavigationIndex !== notFocusedIndex && navigationIndex === addButtonIndex && this.element) {
      this.element.focus();
    }
  },
  methods: {
    focus: function focus() {
      if (this.element) {
        this.element.focus();
      }
    },
    onClick: function onClick() {
      this.$emit('click', this.$props.addButtonIndex);
    },
    onAdd: function onAdd(files) {
      this.$emit('add', files);
    },
    onInputMouseDown: function onInputMouseDown(e) {
      if (this.element) {
        e.preventDefault();
        this.element.focus();
      }
    },
    actionElement: function actionElement() {
      if (this.uploadInput) {
        return this.uploadInput.actionElement;
      }
    }
  },
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        navigationIndex = _a.navigationIndex,
        addButtonIndex = _a.addButtonIndex,
        tabIndex = _a.tabIndex,
        id = _a.id,
        ariaLabelledBy = _a.ariaLabelledBy,
        ariaDescribedBy = _a.ariaDescribedBy,
        async = _a.async,
        multiple = _a.multiple,
        disabled = _a.disabled,
        accept = _a.accept;
    var localizationService = provideLocalizationService(this);
    var selectMessage = localizationService.toLanguageString(select, messages[select]);
    var buttonClassName = classNames('k-button', 'k-button-md', 'k-button-solid', 'k-button-solid-base', 'k-rounded-md', 'k-upload-button', navigationIndex === addButtonIndex ? 'k-focus' : '');
    return h("div", {
      id: id,
      attrs: this.v3 ? undefined : {
        id: id,
        role: "button",
        "aria-label": selectMessage,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        tabIndex: tabIndex
      },
      ref: this.v3 ? function (el) {
        _this.elementRef = el;
      } : 'element',
      role: "button",
      "class": buttonClassName,
      "aria-label": selectMessage,
      "aria-labelledby": ariaLabelledBy,
      "aria-describedby": ariaDescribedBy,
      tabIndex: tabIndex,
      onClick: this.onClick,
      on: this.v3 ? undefined : {
        "click": this.onClick
      }
    }, [// @ts-ignore  function children
    h(UploadInput, {
      async: async,
      attrs: this.v3 ? undefined : {
        async: async,
        multiple: multiple,
        disabled: disabled,
        accept: accept
      },
      multiple: multiple,
      disabled: disabled,
      accept: accept,
      onMousedown: this.onInputMouseDown,
      on: this.v3 ? undefined : {
        "mousedown": this.onInputMouseDown,
        "add": this.onAdd
      },
      onAdd: this.onAdd,
      ref: this.v3 ? function (el) {
        _this.uploadInputRef = el;
      } : 'uploadInput'
    }), h("span", [selectMessage])]);
  }
};
var UploadAddButton = UploadAddButtonVue2;
export { UploadAddButton, UploadAddButtonVue2 };